/**
 * Public Route Component
 * For auth pages (login, register) - redirects authenticated users
 * Special case: allows authenticated users to access login page for remember-me functionality
 */

import { type ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '@shared/contexts'
import { LoadingPage } from '@shared/components/feedback'

interface PublicRouteProps {
  children: ReactNode
}

export function PublicRoute({ children }: PublicRouteProps) {
  const { isAuthenticated, isLoading, authChecked } = useAuth()
  const location = useLocation()

  // Show loading while checking authentication
  if (isLoading || !authChecked) {
    return <LoadingPage />
  }

  // Allow authenticated users to view login page (for remember-me settings)
  // But redirect from register and password recovery pages
  if (isAuthenticated && location.pathname !== '/login') {
    return <Navigate to="/" replace />
  }

  return <>{children}</>
}
